"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJsonValue = void 0;
const isJsonObject_1 = require("./isJsonObject");
function isJsonValue(value) {
    if (value === null) {
        return true;
    }
    if (typeof value === "number") {
        return true;
    }
    if (typeof value === "string") {
        return true;
    }
    if (typeof value === "boolean") {
        return true;
    }
    if (typeof value === "bigint") {
        return true;
    }
    if (Array.isArray(value)) {
        for (const item of value) {
            if (!isJsonValue(item)) {
                return false;
            }
        }
        return true;
    }
    return (0, isJsonObject_1.isJsonObject)(value);
}
exports.isJsonValue = isJsonValue;
//# sourceMappingURL=isJsonValue.js.map